module.exports = __webpack_public_path__ + "static/media/7.bdb16225.jpg";